import React from "react";
import "./Footer.css";

export default function Footer() {
    
    return (
        <footer className="Footer">
            <div >
                <div>
                    <div className="col-xs-10 col-sm-8 col-lg-6 footer-container">
                        <ul className="footer-menu">
                            <li>
                                <span aria-label=" Made in NYC " >
                                        Made in NYC 
                                </span>
                            </li> 
                            <li>
                                |
                            </li> 
                            <li>
                                <span>
                                    <a href="https://sertify.io/terms" target="_blank" rel="noopener noreferrer" id="requestPrivacyNotice" aria-label=" Terms of use  ">
                                        Terms 
                                    </a>
                                </span>
                            </li> 
                            <li>
                                |
                            </li> 
                            <li>
                                <span id="requestTermsOfUse-link-wrapper">
                                    <a href="https://sertify.io/privacy" target="_blank" rel="noopener noreferrer" id="requestTermsOfUse" aria-label=" Privacy ">
                                        Privacy
                                    </a>
                                </span>
                            </li> 
                            <li>
                                |
                            </li> 
                            <li>
                                <span>
                                    <a href="https://sertify.io/accessibility" target="_blank" rel="noopener noreferrer" id="requestPrivacyNotice" aria-label=" Accessibility  ">
                                        Accessibility 
                                    </a>
                                </span>
                            </li> 
                            <li>
                                |
                            </li> 
                            <li>
                                <span aria-label=" Copyright Sertify, Inc." >
                                    &copy; 2025 Sertify, Inc. 
                                </span>
                            </li> 
                        </ul> 
                    </div>
                </div>
            </div>
        </footer>
    );
}